import styled from 'styled-components';
import { IThemeProvider } from '../../styles/theme';

export const TableFooter = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({theme}: IThemeProvider) => `
      margin:  0 0 ${theme.layout.spacing.hekto} 0;
   `}
`;